<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-14 15:11:07
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-06-23 10:53:39
 * @Description: 输入框组件
 * @FilePath: /hsylc2021/src/components/form/Input/index.vue
-->
<template>
  <div class="component-input" :class="computedClass">
    <div class="input-render">
      <label class="component-label" v-if="label !== ''">{{ label }}</label>
      <input
        :type="type"
        class="component-inner-input w-normal"
        :placeholder="placeholder"
        @focus="handleInputFocused"
        @blur="handleInputBlur"
        @mouseover="handleInputMouseOver"
        @mouseout="handleInputMouseOut"
        :value="value"
        @input="handleInputChange"
        :disabled="disabled"
        autocomplete="new-password"
        @keyup="handleKeyUp"
        :maxlength="maxlength"
        ref="input"
      />
    </div>
    <p class="component-message w-bold" v-if="showMsg && msg && msg !== ''">{{ msg }}</p>
  </div>
</template>
<script>
/**
 * input 组件
 * @module Input
 */
export default {
  name: 'Input',
  /**
   * @prop {String} size 大小/高度 normal-48 small-36  默认normal
   * @prop {String} label 输入框标签 默认无，不展示
   * @prop {String} placeholder 水印文字 默认无，不展示
   * @prop {String} className 组件class
   * @prop {String} msg 提示文字 默认无，不展示
   * @prop {Boolean} showMsg 是否显示提示文字 默认true
   * @prop {Boolean} error 是否错误状态
   * @prop {Boolean} disabled 是否禁用状态
   * @prop {String} value 输入框内容
   * @prop {String} type 输入框类型 与input一致
   * @prop {Boolean} isFocus 是否聚焦 默认false
   * @prop {Boolean} isHover 是否鼠标覆盖 默认false
   */
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      default: ''
    },
    showMsg: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    isFocus: {
      type: Boolean,
      default: false
    },
    isHover: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: -1
    },
    reg: {
      type: RegExp,
      default: null
    }
  },
  /**
   * @prop {Object} computedClass 组件class计算
   * @prop {Boolean} isActive 计算组件是否整体为聚焦状态
   * @prop {Boolean} isDone 计算组件是否已经填写
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[`size-${this.size}`] = true;
      ret[this.className] = true;
      ret['disabled'] = this.disabled;
      ret['hover'] = this.hover;
      ret['active'] = this.isActive;
      ret['done'] = this.isDone;
      ret['error'] = this.error;
      ret['no-opacity'] = this.label === '';
      return ret;
    },
    isActive() {
      let ret = false;
      if (this.focused) {
        ret = true;
      }
      return ret;
    },
    isDone() {
      let ret = false;
      if (this.value && this.value !== '') {
        ret = true;
      }
      return ret;
    }
  },
  /**
   * @prop {Boolean} focused 事件聚焦状态
   * @prop {Boolean} hover 记录覆盖状态
   */
  data: () => ({
    focused: false,
    hover: false
  }),
  watch: {
    isFocus() {
      this.focused = this.isFocus;
    },
    isHover() {
      this.hover = this.isHover;
    }
  },
  mounted() {
    this.focused = this.isFocus;
    this.hover = this.isHover;
  },
  methods: {
    /**
     * @event focus 聚焦事件
     * @param {Object} e 事件对象
     */
    focus: function(e) {
      this.$emit('focus', e);
    },
    /**
     * @event blur 失去焦点事件
     * @param {Object} e 事件对象
     */
    blur: function(e) {
      this.$emit('blur', e);
    },
    /**
     * @event mouseOver 鼠标覆盖事件
     * @param {Object} e 事件对象
     */
    mouseOver: function(e) {
      this.$emit('mouseOver', e);
    },
    /**
     * @event mourseOut 鼠标离开事件
     * @param {Object} e 事件对象
     */
    mouseOut: function(e) {
      this.$emit('mouseOut', e);
    },
    /**
     * @event input 输入事件
     * @param {String} val 输入内容
     */
    input: function(val) {
      this.$emit('input', val);
    },
    /**
     * @description 输入框聚焦事件
     * @function handleInputFocused
     * @param {Object} e 事件对象
     */
    handleInputFocused: function(e) {
      this.focused = true;
      this.focus(e);
    },
    /**
     * @description 输入框失去焦点
     * @function handleInputBlur
     * @param {Object} e 事件对象
     */
    handleInputBlur: function(e) {
      this.focused = false;
      this.blur(e);
    },
    /**
     * @description 鼠标覆盖输入框
     * @function handleInputMouseOver
     * @param {Object} e 事件对象
     */
    handleInputMouseOver: function(e) {
      this.hover = true;
      this.mouseOver(e);
    },
    /**
     * @description 鼠标移出输入框
     * @function handleInputMouseOut
     * @param {Object} e 事件对象
     */
    handleInputMouseOut: function(e) {
      this.hover = false;
      this.mouseOut(e);
    },
    /**
     * @description 输入事件
     * @function handleInputChange
     * @param {Object} e 事件对象
     */
    handleInputChange: function(e) {
      let value = e.target.value;
      if (this.reg && !this.reg.test(value) && value !== '') {
        value = this.value;
        if (this.$refs.input) {
          this.$refs.input.value = value;
        }
      }
      this.input(value);
    },
    /**
     * @event keyup keyup事件
     */
    /**
     * @description keyup事件
     * @function handleKeyUp
     * @param {Object} e 事件对象
     */
    handleKeyUp: function(e) {
      this.$emit('keyup', e);
    }
  }
};
</script>
<style lang="less" src="./index.less" scoped></style>
